

export function header($) {


  //----------------------------------------------------
  // BUTTON  MENU
  //----------------------------------------------------

  const $burgerMenu = $('.button-burger-menu');
  $burgerMenu.click(function (event) {
    event.preventDefault();
    $(this)
      .toggleClass('active');
    $('body')
      .toggleClass('visibleMenu');
  });

}
